import { render, staticRenderFns } from "./ChargeEditor.vue?vue&type=template&id=b5af7374&scoped=true&"
import script from "./ChargeEditor.vue?vue&type=script&lang=js&"
export * from "./ChargeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5af7374",
  null
  
)

export default component.exports